/**
 * Kartla ödeme sağlayıcısı seçimi (F3B-06, ADR-100). Test ortamındayken sağlayıcı normalde test (sandbox)
 * bağlantısı olmadan seçilemez. İşletme sahibi ise test bağlantısı olmayan ama canlı bağlantısı çalışan bir
 * sağlayıcıyı seçebilir; seçim doğrudan "Canlıya geç" penceresini açar ve tek istekte sağlayıcı + canlı ortam
 * gönderilir. Sahip olmayanlar için kural değişmez (önce test bağlantısı ve test ödemesi).
 */
export interface ProviderConnections {
  provider: string;
  sandbox: string;
  live: string;
}

export type ProviderChoice = 'select' | 'go_live' | 'disabled';

export function providerChoice(
  p: ProviderConnections,
  environment: 'sandbox' | 'live',
  isOwner: boolean,
): ProviderChoice {
  if (environment === 'live') return p.live === 'LIVE' ? 'select' : 'disabled';
  if (p.sandbox === 'SANDBOX') return 'select';
  return isOwner && p.live === 'LIVE' ? 'go_live' : 'disabled';
}

/**
 * "Canlıya geç" penceresinin açılacağı sağlayıcı: seçili sağlayıcı; yoksa (yalnızca sahip için) canlı bağlantısı
 * çalışan ilk sağlayıcı. Yoksa null (düğme gösterilmez).
 */
export function goLiveTarget(
  providers: ProviderConnections[],
  selected: string | null,
  isOwner: boolean,
): string | null {
  if (selected) return selected;
  if (!isOwner) return null;
  return providers.find((p) => p.live === 'LIVE')?.provider ?? null;
}
